(() => {
  const SECTION_ID = "template--25667202580853__main"; // falls bei dir fix. Wenn nicht: dynamisch unten
  const inputSelector = 'input[name="quantity"]';

  function forceQtyToOne() {
    return;
    const input = document.querySelector(inputSelector);
    if (!input) return;

    // input.value = 1;
    input.setAttribute("value", "1");
    input.setAttribute("min", "1");
    input.setAttribute("step", "1");

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // initial
  document.addEventListener("DOMContentLoaded", () => {
    forceQtyToOne();
  });

  // Eurus Events (falls SECTION_ID dynamisch ist, kannst du einfach ohne suffix lauschen)
  document.addEventListener(`eurus:product-page-variant-select:updated:${SECTION_ID}`, () => {
    setTimeout(forceQtyToOne, 0);
  });

  document.addEventListener(`eurus:product-card-variant-select:updated:${SECTION_ID}`, () => {
    setTimeout(forceQtyToOne, 0);
  });

  // fallback: wenn quantity block ersetzt wird
  const mo = new MutationObserver(() => forceQtyToOne());
  mo.observe(document.documentElement, { subtree: true, childList: true });
})();
